import { createSlice, current } from '@reduxjs/toolkit';




const initialState = {
    recipe:[]
};

export const recipeSlice = createSlice({
  name: 'recipe',
  initialState,
  reducers: {
    setRecipe: (state, { payload }) => {
     
      state.recipe = [...payload];
    },
    
   
    clearRecipeState: (state) => {
      state=initialState
    }
  }
});

export const { setRecipe, clearRecipeState } = recipeSlice.actions;

export const recipeData = (state) => state.recipe;


export default recipeSlice.reducer;
